"use client";

import { c as _c } from "react/compiler-runtime";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { DRAG_DROP_PASTE } from "@lexical/rich-text";
import { isMimeType, mediaFileReader } from "@lexical/utils";
import { $getNodeByKey, $insertNodes, COMMAND_PRIORITY_LOW } from "lexical";
import { useEffect } from "react";
import { $createImageNode } from "../nodes/ImageNode";
import { multiPartUpload } from "@/components/waves/create-wave/services/multiPartUpload";
import { useAuth } from "@/components/auth/Auth";
const ACCEPTABLE_IMAGE_TYPES = ["image/", "image/heic", "image/heif", "image/gif", "image/webp"];
async function uploadImage(file: File): Promise<string> {
  const multiPart = await multiPartUpload({
    file,
    path: "drop"
  });
  return multiPart.url;
}
export default function DragDropPaste() {
  const $ = _c(4);
  const {
    setToast
  } = useAuth();
  const [editor] = useLexicalComposerContext();
  let t0;
  let t1;
  if ($[0] !== editor || $[1] !== setToast) {
    t0 = () => {
      let isMounted = true;
      const unregister = editor.registerCommand(DRAG_DROP_PASTE, files => {
        (async () => {
          const filesResult = await mediaFileReader(files, [ACCEPTABLE_IMAGE_TYPES].flatMap(_temp));
          if (filesResult.length === 0) {
            setToast({
              message: "Unsupported file type for Drag & Drop / Paste.",
              type: "error"
            });
            return;
          }
          for (const {
            file
          } of filesResult) {
            if (isMimeType(file, ACCEPTABLE_IMAGE_TYPES)) {
              editor.update(() => {
                const imageNode = $createImageNode({
                  src: "loading"
                });
                $insertNodes([imageNode]);
                const key = imageNode.getKey();
                uploadImage(file).then(url => {
                  if (!isMounted) {
                    return;
                  }
                  editor.update(() => {
                    const node = $getNodeByKey(key);
                    if (node) {
                      node.replace($createImageNode({
                        src: url
                      }));
                    }
                  });
                }).catch(() => {
                  if (!isMounted) {
                    return;
                  }
                  editor.update(() => {
                    const node_0 = $getNodeByKey(key);
                    if (node_0) {
                      node_0.remove();
                    }
                  });
                });
              });
            }
          }
        })();
        return true;
      }, COMMAND_PRIORITY_LOW);
      return () => {
        unregister();
        isMounted = false;
      };
    };
    t1 = [editor, setToast];
    $[0] = editor;
    $[1] = setToast;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}
function _temp(x) {
  return x;
}